const types = {
  // user courses
  USER_COURSES: "USER_COURSES",
  USER_COURSES_RESPONSE: "USER_COURSES_RESPONSE",
  USER_COURSES_CLEAR: "USER_COURSES_CLEAR",

  // user courses
  IN_PROGRESS_BROKER: "IN_PROGRESS_BROKER",
  IN_PROGRESS_BROKER_RESPONSE: "IN_PROGRESS_BROKER_RESPONSE",
  IN_PROGRESS_BROKER_CLEAR: "IN_PROGRESS_BROKER_CLEAR",

  // my courses
  MY_COURSES: "MY_COURSES",
  MY_COURSES_RESPONSE: "MY_COURSES_RESPONSE",
  MY_COURSES_CLEAR: "MY_COURSES_CLEAR",

  // my Action Path
  MY_LEARNING_PATHS: "MY_LEARNING_PATHS",
  MY_LEARNING_PATHS_RESPONSE: "MY_LEARNING_PATHS_RESPONSE",
  MY_LEARNING_PATHS_CLEAR: "MY_LEARNING_PATHS_CLEAR",

  LEARNING_PATHS_UNASSIGNED: "LEARNING_PATHS_UNASSIGNED",
  LEARNING_PATHS_UNASSIGNED_RESPONSE: "LEARNING_PATHS_UNASSIGNED_RESPONSE",
  LEARNING_PATHS_UNASSIGNED_CLEAR: "LEARNING_PATHS_UNASSIGNED_CLEAR",

  // SINGLE LP
  SINGLE_LP_DATA: "SINGLE_LP_DATA",
  SINGLE_LP_DATA_RESPONSE: "SINGLE_LP_DATA_RESPONSE",
  SINGLE_LP_DATA_CLEAR: "SINGLE_LP_DATA_CLEAR",

  // courses categories
  COURSE_CATEGORIES: "COURSE_CATEGORIES",
  COURSE_CATEGORIES_RESPONSE: "COURSE_CATEGORIES_RESPONSE",
  COURSE_CATEGORIES_CLEAR: "COURSE_CATEGORIES_CLEAR",

  // product categories
  PRODUCT_CATEGORIES: "PRODUCT_CATEGORIES",
  PRODUCT_CATEGORIES_RESPONSE: "PRODUCT_CATEGORIES_RESPONSE",
  PRODUCT_CATEGORIES_CLEAR: "PRODUCT_CATEGORIES_CLEAR",

  // video product categories
  VIDEO_PRODUCT_CATEGORIES: "VIDEO_PRODUCT_CATEGORIES",
  VIDEO_PRODUCT_CATEGORIES_RESPONSE: "VIDEO_PRODUCT_CATEGORIES_RESPONSE",
  VIDEO_PRODUCT_CATEGORIES_CLEAR: "VIDEO_PRODUCT_CATEGORIES_CLEAR",

   // product  categories
  FOR_YOU_DATA: "FOR_YOU_DATA",
  FOR_YOU_DATA_RESPONSE: "FOR_YOU_DATA_RESPONSE",
  FOR_YOU_DATA_CLEAR: "FOR_YOU_DATA_CLEAR",

  // product  categories
  PRODUCT_CATEGORIES_DATA: "PRODUCT_CATEGORIES_DATA",
  PRODUCT_CATEGORIES_DATA_RESPONSE: "PRODUCT_CATEGORIES_DATA_RESPONSE",
  PRODUCT_CATEGORIES_DATA_CLEAR: "PRODUCT_CATEGORIES_DATA_CLEAR",

  PRODUCT_SUB_CATEGORIES_DATA: "PRODUCT_SUB_CATEGORIES_DATA",
  PRODUCT_SUB_CATEGORIES_DATA_RESPONSE: "PRODUCT_SUB_CATEGORIES_DATA_RESPONSE",
  PRODUCT_SUB_CATEGORIES_DATA_CLEAR: "PRODUCT_SUB_CATEGORIES_DATA_CLEAR",

  //selected category
  SELECTED_CATEGORY: "SELECTED_CATEGORY",

  // courses listing
  COURSES_LISTING: "COURSES_LISTING",
  COURSES_LISTING_RESPONSE: "COURSES_LISTING_RESPONSE",
  COURSES_LISTING_CLEAR: "COURSE_CATEGORIES_CLEAR",

  // Modules listing
  MODULE_LISTING: "MODULE_LISTING",
  MODULE_LISTING_RESPONSE: "MODULE_LISTING_RESPONSE",
  MODULE_LISTING_CLEAR: "MODULE_CATEGORIES_CLEAR",
  // Modules listing
  COURSE_DETAIL_ECOM: "COURSE_DETAIL_ECOM",
  COURSE_DETAIL_ECOM_RESPONSE: "COURSE_DETAIL_ECOM_RESPONSE",
  COURSE_DETAIL_ECOM_CLEAR: "MODULE_CATEGORIES_CLEAR",
  // ModuleNotesGet
  MODULE_NOTES_GET: "MODULE_NOTES_GET",
  MODULE_NOTES_GET_RESPONSE: "MODULE_NOTES_GET_RESPONSE",
  MODULE_NOTES_GET_CLEAR: "MODULE_NOTES_GET_CLEAR",
  // ModuleNotesUpdate
  MODULE_NOTES_UPDATE: "MODULE_NOTES_UPDATE",
  MODULE_NOTES_UPDATE_RESPONSE: "MODULE_NOTES_UPDATE_RESPONSE",
  MODULE_NOTES_UPDATE_CLEAR: "MODULE_NOTES_UPDATE_CLEAR",
  // ModuleNotesDelete
  MODULE_NOTES_DELETE: "MODULE_NOTES_DELETE",
  MODULE_NOTES_DELETE_RESPONSE: "MODULE_NOTES_DELETE_RESPONSE",
  MODULE_NOTES_DELETE_CLEAR: "MODULE_NOTES_DELETE_CLEAR",
  // ModuleFavouritesGet
  MODULE_FAV_GET: "MODULE_FAV_GET",
  MODULE_FAV_GET_RESPONSE: "MODULE_FAV_GET_RESPONSE",
  MODULE_FAV_GET_CLEAR: "MODULE_FAV_GET_CLEAR",

  // ModuleFavouritesDelete
  MODULE_FAV_DELETE: "MODULE_FAV_DELETE",
  MODULE_FAV_DELETE_RESPONSE: "MODULE_FAV_DELETE_RESPONSE",
  MODULE_FAV_DELETE_CLEAR: "MODULE_FAV_DELETE_CLEAR",

  // favorite courses
  FAVORITE_COURSES: "FAVORITE_COURSES",
  FAVORITE_COURSES_RESPONSE: "FAVORITE_COURSES_RESPONSE",
  FAVORITE_COURSES_CLEAR: "FAVORITE_COURSES_CLEAR",

  // set favorite courses
  SET_FAVORITE_COURSES: "SET_FAVORITE_COURSES",
  SET_FAVORITE_COURSES_RESPONSE: "SET_FAVORITE_COURSES_RESPONSE",
  SET_FAVORITE_COURSES_CLEAR: "SET_FAVORITE_COURSES_CLEAR",

  // remove favorite courses
  REMOVE_FAVORITE_COURSES: "REMOVE_FAVORITE_COURSES",
  REMOVE_FAVORITE_COURSES_RESPONSE: "REMOVE_FAVORITE_COURSES_RESPONSE",
  REMOVE_FAVORITE_COURSES_CLEAR: "REMOVE_FAVORITE_COURSES_CLEAR",

  //show Buy Modal
  SHOW_BUY_MODAL: "SHOW_BUY_MODAL",

  // Action Path
  LEARNING_PATH: "LEARNING_PATH",
  LEARNING_PATH_RESPONSE: "LEARNING_PATH_RESPONSE",
  LEARNING_PATH_CLEAR: "LEARNING_PATH_CLEAR",

  // Action Path broker
  LEARNING_PATH_BROKER: "LEARNING_PATH_BROKER",
  LEARNING_PATH_BROKER_RESPONSE: "LEARNING_PATH_BROKER_RESPONSE",
  LEARNING_PATH_BROKER_CLEAR: "LEARNING_PATH_BROKER_CLEAR",

  // oblp
  UNASSIGNED_OBLP: "UNASSIGNED_OBLP",
  UNASSIGNED_OBLP_RESPONSE: "UNASSIGNED_OBLP_RESPONSE",
  UNASSIGNED_OBLP_CLEAR: "UNASSIGNED_OBLP_CLEAR",

  OPEN_HAMBURGER: "OPEN_HAMBURGER",
  OPEN_HAMBURGER_CLEAR: "OPEN_HAMBURGER_CLEAR",

  // courses listing from WOO commerse
  COURSES_LISTING_WOO: "COURSES_LISTING_WOO",
  COURSES_LISTING_RESPONSE_WOO: "COURSES_LISTING_RESPONSE_WOO",
  COURSES_LISTING_CLEAR_WOO: "COURSE_CATEGORIES_CLEAR_WOO",

  // courses listing from Broker admin
  COURSES_CATEGORIES_BROKER: "COURSES_CATEGORIES_BROKER",
  COURSES_CATEGORIES_RESPONSE_BROKER: "COURSES_CATEGORIES_RESPONSE_BROKER",
  COURSES_CATEGORIES_CLEAR_BROKER: "COURSE_CATEGORIES_CLEAR_BROKER",

  // courses listing from Broker admin
  COURSES_LISTING_BROKER: "COURSES_LISTING_BROKER",
  COURSES_LISTING_RESPONSE_BROKER: "COURSES_LISTING_RESPONSE_BROKER",
  COURSES_LISTING_CLEAR_BROKER: "COURSE_CATEGORIES_CLEAR_BROKER",

  // courses listing from Broker admin
  MODULES_LISTING_BROKER: "MODULES_LISTING_BROKER",
  MODULES_LISTING_RESPONSE_BROKER: "MODULES_LISTING_RESPONSE_BROKER",
  MODULES_LISTING_CLEAR_BROKER: "MODULES_CATEGORIES_CLEAR_BROKER",

  ASSIGN_COURSE: "ASSIGN_COURSE",
  ASSIGN_COURSE_RESPONSE: "ASSIGN_COURSE_RESPONSE",
  ASSIGN_COURSE_CLEAR: "ASSIGN_COURSE_CLEAR",

  ASSIGN_COURSE_BROKER: "ASSIGN_COURSE_BROKER",
  ASSIGN_COURSE_BROKER_RESPONSE: "ASSIGN_COURSE_BROKER_RESPONSE",
  ASSIGN_COURSE_BROKER_CLEAR: "ASSIGN_COURSE_BROKER_CLEAR",

  ASSIGN_COURSE_BROKERLP: "ASSIGN_COURSE_BROKERLP",
  ASSIGN_COURSE_BROKER_RESPONSELP: "ASSIGN_COURSE_BROKER_RESPONSELP",
  ASSIGN_COURSE_BROKER_CLEARLP: "ASSIGN_COURSE_BROKER_CLEARLP",

  MARK_VIEW: "MARK_VIEW",
  MARK_VIEW_RESPONSE: "MARK_VIEW_RESPONSE",
  MARK_VIEW_CLEAR: "MARK_VIEW_CLEAR",

  // courses code of Ethics

  MASTER_CODE_OF_ETHICS: "MASTER_CODE_OF_ETHICS",
  MASTER_CODE_OF_ETHICS_RESPONSE: "MASTER_CODE_OF_ETHICS_RESPONSE",
  MASTER_CODE_OF_ETHICS_CLEAR: "MASTER_CODE_OF_ETHICS_CLEAR",

  // Course Ethics Agree Check

  ETHICS_AGREE_CHECK: "ETHICS_AGREE_CHECK",
  ETHICS_AGREE_CHECK_RESPONSE: "ETHICS_AGREE_CHECK_RESPONSE",
  ETHICS_AGREE_CHECK_CLEAR: "ETHICS_AGREE_CHECK_CLEAR",

  MARK_MODULE_PROGRESS: "MARK_MODULE_PROGRESS",
  MARK_MODULE_PROGRESS_RESPONSE: "MARK_MODULE_PROGRESS_RESPONSE",
  MARK_MODULE_PROGRESS_CLEAR: "MARK_MODULE_PROGRESS_CLEAR",

  RECOMMEND_IDS: "RECOMMEND_IDS",
  RECOMMEND_IDS_RESPONSE: "RECOMMEND_IDS_RESPONSE",
  RECOMMEND_IDS_CLEAR: "RECOMMEND_IDS_CLEAR",

  SAVE_ANSWERS: "SAVE_ANSWERS",
  SAVE_ANSWERS_RESPONSE: "SAVE_ANSWERS_RESPONSE",
  SAVE_ANSWERS_CLEAR: "SAVE_ANSWERS_CLEAR",

  GET_LEVEL_DETAIL_REQ: "GET_LEVEL_DETAIL_REQ",
  GET_LEVEL_DETAIL_RESPONSE: "GET_LEVEL_DETAIL_RESPONSE",
  GET_LEVEL_DETAIL_RESPONSE_CLEAR: "GET_LEVEL_DETAIL_RESPONSE_CLEAR",
  //

  CHECKLIST_INSERT: "CHECKLIST_INSERT",
  CHECKLIST_INSERT_RESPONSE: "CHECKLIST_INSERT_RESPONSE",
  CHECKLIST_INSERT_RESPONSE_CLEAR: "CHECKLIST_INSERT_RESPONSE_CLEAR",

  // RELATED COURSE BY CAT ID
  COURSE_RELATED: "COURSE_RELATED",
  COURSE_RELATED_RESPONSE: "COURSE_RELATED_RESPONSE",
  COURSE_RELATED_CLEAR: "COURSE_RELATED_CLEAR",

  //Popular Courses
  POPULAR_COURSES: "POPULAR_COURSES",
  POPULAR_COURSES_RESPONSE: "POPULAR_COURSES_RESPONSE",
  POPULAR_COURSES_CLEAR: "POPULAR_COURSES_CLEAR",

  //Useful Courses
  USEFUL_COURSES: " USEFUL_COURSES",
  USEFUL_COURSES_RESPONSE: " USEFUL_COURSES_RESPONSE",
  USEFUL_COURSES_CLEAR: " USEFUL_COURSES_CLEAR",

  //Popular Free Courses
  POPULAR_FREE_COURSES: "POPULAR_FREE_COURSES",
  POPULAR_FREE_COURSES_RESPONSE: "POPULAR_FREE_COURSES_RESPONSE",
  POPULAR_FREE_COURSES_CLEAR: "POPULAR_FREE_COURSES_CLEAR",

  //Courses Included with Paid subscription
  COURSES_INCLUDED_WITH_PAID_SUBSCRIPTION:
    "COURSES_INCLUDED_WITH_PAID_SUBSCRIPTION",
  COURSES_INCLUDED_WITH_PAID_SUBSCRIPTION_RESPONSE:
    "COURSES_INCLUDED_WITH_PAID_SUBSCRIPTION_RESPONSE",
  COURSES_INCLUDED_WITH_PAID_SUBSCRIPTION_CLEAR:
    "COURSES_INCLUDED_WITH_PAID_SUBSCRIPTION_CLEAR",

  //Courses Included with Higher subscription
  COURSES_INCLUDED_WITH_HIGHER_SUBSCRIPTION:
    "COURSES_INCLUDED_WITH_HIGHER_SUBSCRIPTION",
  COURSES_INCLUDED_WITH_HIGHER_SUBSCRIPTION_RESPONSE:
    "COURSES_INCLUDED_WITH_HIGHER_SUBSCRIPTION_RESPONSE",
  COURSES_INCLUDED_WITH_HIGHER_SUBSCRIPTION_CLEAR:
    "COURSES_INCLUDED_WITH_HIGHER_SUBSCRIPTION_CLEAR",

  GET_CATEGORY_LIST_NEW_REQ: "GET_CATEGORY_LIST_NEW_REQ",
  GET_CATEGORY_LIST_NEW_RESPONSE: "GET_CATEGORY_LIST_NEW_RESPONSE",
  GET_CATEGORY_LIST_NEW_CLEAR: "GET_CATEGORY_LIST_NEW_CLEAR",

  //Global Search Courses
  GLOBAL_SEARCH_COURSES: " GLOBAL_SEARCH_COURSES",
  GLOBAL_SEARCH_COURSES_RESPONSE: " GLOBAL_SEARCH_COURSES_RESPONSE",
  GLOBAL_SEARCH_COURSES_CLEAR: " GLOBAL_SEARCH_COURSES_CLEAR",

  //upcoming courses

  GET_UPCOMING_COURSES: "GET_UPCOMING_COURSES",
  GET_UPCOMING_COURSES_RESPONSE: "GET_UPCOMING_COURSES_RESPONSE",
  GET_UPCOMING_COURSES_CLEAR: "GET_UPCOMING_COURSES_CLEAR",

  //TAGS
  TAGS: "TAGS",
  TAGS_RESPONSE: "TAGS_RESPONSE",
  TAGS_RESPONSE_CLEAR: "TAGS_RESPONSE_CLEAR",

  DELETE_CAOCH_REQ: "DELETE_CAOCH_REQ",
  DELETE_CAOCH_RESPONSE: "DELETE_CAOCH_RESPONSE",
  DELETE_CAOCH_CLEAR: "DELETE_CAOCH_CLEAR",

  //get rank status
  RANK_STATUS: "RANK_STATUS",
  RANK_STATUS_RESPONSE: "RANK_STATUS_RESPONSE",
  RANK_STATUS_CLEAR: "RANK_STATUS_CLEAR",

  //get Dynamic Text 
  DYNAMIC_TEXT: "DYNAMIC_TEXT",
  DYNAMIC_TEXT_RESPONSE: "DYNAMIC_TEXT_RESPONSE",
  DYNAMIC_TEXT_CLEAR: "DYNAMIC_TEXT_CLEAR",

  //get activity status
  ACTIVITY_RING: "ACTIVITY_RING",
  ACTIVITY_RING_RESPONSE: "ACTIVITY_RING_RESPONSE",
  ACTIVITY_RING_CLEAR: "ACTIVITY_RING_CLEAR",
};

export default types;
